/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiArtifactBookmarkFromJSON(json) {
    return StreemApiArtifactBookmarkFromJSONTyped(json, false);
}
export function StreemApiArtifactBookmarkFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'label': !exists(json, 'label') ? undefined : json['label'],
        'timestamp': !exists(json, 'timestamp') ? undefined : (new Date(json['timestamp'])),
        'status': !exists(json, 'status') ? undefined : json['status'],
        'deletedAt': !exists(json, 'deleted_at') ? undefined : (new Date(json['deleted_at'])),
    };
}
export function StreemApiArtifactBookmarkToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'label': value.label,
        'timestamp': value.timestamp === undefined ? undefined : (value.timestamp.toISOString()),
        'status': value.status,
        'deleted_at': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiArtifactBookmarkStatus;
(function (StreemApiArtifactBookmarkStatus) {
    StreemApiArtifactBookmarkStatus["CAPTURED"] = "STATUS_CAPTURED";
    StreemApiArtifactBookmarkStatus["ERROR"] = "STATUS_ERROR";
    StreemApiArtifactBookmarkStatus["FULFILLED"] = "STATUS_FULFILLED";
    StreemApiArtifactBookmarkStatus["REJECTED"] = "STATUS_REJECTED";
    StreemApiArtifactBookmarkStatus["STARTED"] = "STATUS_STARTED";
    StreemApiArtifactBookmarkStatus["UNKNOWN"] = "STATUS_UNKNOWN";
})(StreemApiArtifactBookmarkStatus || (StreemApiArtifactBookmarkStatus = {}));
//# sourceMappingURL=StreemApiArtifactBookmark.js.map